import { connect } from 'react-redux'

import AclRoute from './AclRoute'

const mapStateToProps = state => {
  return {
    features: state.appReducer.features,
  }
}

export default connect(mapStateToProps, null)(AclRoute)
